import { useSetRecoilState } from "recoil";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { snackbarAtom } from "../../states/Atoms/StatusAtoms";
import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import { Modal } from "@mui/material";

const WorksComponent = () => {
  const setSnackbarState = useSetRecoilState(snackbarAtom);

  const [invNo, setInvNo] = useState("");
  const [rptNo, setRptNo] = useState("");
  // 외부 모달을 여는 함수 정의 예시
  const [openExternalModal, setOpenExternalModal] = useState(false);


  // 문자열 -> 배열 변환
  const parseInvNos = (raw) => {
    const tokens = raw
      .split(/[,\n\r\t]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    return Array.from(new Set(tokens));
  };

  const handleSubmit = async () => {
    try {
      const invNos = parseInvNos(invNo);
      const cleanRptNo = rptNo.replace(/[\s-]+/g, "");

      if (invNos.length === 0) {
        setSnackbarState({
          isOpen: true,
          text: "인보이스 번호를 최소 1개 이상 입력하세요",
          severity: "warning",
        });
        return;
      }
      if (!cleanRptNo) {
        setSnackbarState({
          isOpen: true,
          text: "신고서 번호를 입력하세요",
          severity: "warning",
        });
        return;
      }

      const payload = { invNo: invNos, rptNo: cleanRptNo };

      const res = await IVISAxios.patch("/master", payload);

      if (res?.data?.success) {
        setSnackbarState({
          isOpen: true,
          text: "신고번호 업데이트 완료",
          severity: "success",
        });
      } else {
        setSnackbarState({
          isOpen: true,
          text: res?.data?.message || "업데이트 실패.",
          severity: "warning",
        });
      }
    } catch (err) {
      setSnackbarState({
        isOpen: true,
        text: "업데이트 중 오류 발생. 신고번호를 확인하세요.",
        severity: "warning",
      });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "20px",
        width: "calc(100% - 40px)",
        maxWidth: "650px",
        border: "2px solid #efefef",
        borderRadius: "5px",
        boxShadow:
          "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      }}
    >
     
     
     
  
      <Typography component="h2" sx={{ fontSize: "20px" }}>
        TCMS 신고번호 업데이트
      </Typography>

      <Typography component="p" sx={{ fontSize: "14px", color: "red" }}>
        * 신고번호는 작업 1회 당 1개만 입력 가능합니다.
      </Typography>

      <Box
        sx={{ display: "flex", gap: "10px", justifyContent: "space-between" }}
      >
        <Box
          sx={{
            display: "flex",
            width: "70%",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <TextField
            label="신고번호(숫자 및 영문만 입력가능)"
            sx={{ width: "full" }}
            value={rptNo}
            onChange={(e) => {
              const cleaned = e.target.value
                .toUpperCase() // 소문자 → 대문자 변환
                .replace(/[\s-]+/g, "") // 공백, 하이픈 제거
                .replace(/[^0-9A-Z]/g, ""); // 숫자+영어 대문자만 허용
              setRptNo(cleaned);
            }}
          />
          <TextField
            label="인보이스 번호를 입력하세요(쉼표로 구분)"
            multiline
            minRows={4}
            value={invNo}
            onChange={(e) => setInvNo(e.target.value)}
          />
        </Box>

        <Button
          variant="contained"
          sx={{ width: 85, height: 56 }}
          onClick={handleSubmit}
        >
          업데이트
        </Button>
      </Box>
    </Box>
  );
};

export default WorksComponent;
